import api from "services/api";

export async function postEmailValidation(
  userId: string | null,
  token: string | null
): Promise<void> {
  await api.post(`/industrial/customer/v1/users/${userId}/validations`, {
    token,
  });
}
